import { render } from "./InstanceMinimalStatusBadge.vue?vue&type=template&id=34183a14"
import script from "./InstanceMinimalStatusBadge.vue?vue&type=script&lang=js"
export * from "./InstanceMinimalStatusBadge.vue?vue&type=script&lang=js"

import "./InstanceMinimalStatusBadge.vue?vue&type=style&index=0&id=34183a14&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__